<template>
  <BaseLayout>
    <BaseDashboard :is-loading="true" />
  </BaseLayout>
</template>
<script>
import { mapActions } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

export default {
  methods: {
    ...mapActions('content', [
      contentTypes.FETCH_CREATIVE_BY_KEY,
    ]),
  },
  created() {
    const { creativeKey } = this.$route.params;
    const { selectedItem } = this.$route.query;
    this.FETCH_CREATIVE_BY_KEY(creativeKey)
      .then((creative) => this.$router
        .replace({
          name: 'Campaign Showcase',
          params: { campaignId: creative.campaignId },
          query: { creativeKey, selectedItem },
        }))
      .catch(() => this.$router.replace('/dashboard'));
  },
};
</script>
